import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

/**
 * The payroll route family's layout shell.
 *
 * A bare `/payroll` is not a screen — the rail links to the component
 * catalogue and the runs list, and the run review is the module's landing
 * concern. Landing on the bare path redirects to the runs list; everything
 * else renders its child directly.
 */
export const Route = createFileRoute('/_authenticated/payroll')({
  beforeLoad: ({ location }) => {
    if (location.pathname === '/payroll') {
      throw redirect({ to: '/payroll/runs' })
    }
  },
  component: PayrollLayoutRoute,
})

function PayrollLayoutRoute() {
  return <Outlet />
}
